import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasConditioner = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('conditioner')(jsonQuery),
);
